import { attempt, isError } from 'lodash';
import { logger, stats } from '@fiverr-private/obs';
import { PERSEUS_NAME, METRICS_PREFIX } from '../constants';

/**
 * @param {() => any} func
 * @param {any} fallback
 * @returns
 */
export const tryInvoke = (func, fallback) => {
    const result = attempt(func);

    if (isError(result)) {
        logger.error(result, {
            description: 'Error in function',
            package: PERSEUS_NAME,
        });
        stats.count(METRICS_PREFIX, 'error');

        return fallback;
    }

    return result;
};
